// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper__Wrapper_2JdKp"};